module.exports = __webpack_public_path__ + "img/slide-16.c5fe83b8.png";